<template>
  <div tabindex="-1" class="modal-content">
    <header class="modal-header bg-primary text-white">
      <h5 class="modal-title">
        {{ options.dialogTitle ? options.dialogTitle : "Confirmation" }}
      </h5>
    </header>
    <div class="modal-body">
      <h6>{{ messageTitle }}</h6>
      <b-form-radio-group
        v-model="selected"
        stacked
        name="dialog-radio-buttons"
      >
        <b-form-radio
          v-for="(option, index) in options.options"
          :key="index"
          :value="option.value"
        >
          {{ option.label }}
        </b-form-radio>
      </b-form-radio-group>
    </div>
    <footer class="modal-footer">
      <button @click="handleConfirm" type="button" class="btn btn-primary">
        Confirm
      </button>
      <button
        @click="handleDismiss"
        type="button"
        class="btn bg-med-light-gray text-white"
      >
        Cancel
      </button>
    </footer>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // Include mixin

export default {
  name: "DialogRadioButtons",
  mixins: [DialogMixin],
  data() {
    return {
      selected: null
    };
  },
  mounted() {
    if (this.options.defaultValue) {
      this.selected = this.options.defaultValue;
    }
  },
  methods: {
    handleConfirm() {
      this.proceed(this.selected); // included in DialogMixin
    },
    handleDismiss() {
      this.cancel(); // included in DialogMixin
    }
  },
  components: {}
};
</script>

<style scoped>
.modal-content {
  margin: -15px;
  width: auto;
}
</style>
